import React, { Component } from 'react';

import { withRouter } from 'react-router';
import IconArrowLeft from '../../assets/icons/IconArrowLeft';

class BackButton extends Component {
    render() {
        return (
            <button type="button" id="btnback" className="flex justify-center items-center h-10 w-10 rounded-full bg-white text-darkblue outline-none focus:outline-none mr-5" onClick={() => this.props.history.goBack()}>
                <IconArrowLeft />
            </button>
        );
    }
}

export default withRouter(BackButton);